export default "__VITE_ASSET__CzQRTHEp__"